module.exports = __webpack_public_path__ + "static/media/app_icon.ffe99383.png";